// @ts-ignore
// @ts-nocheck
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Steps } from 'intro.js-react';
import 'intro.js/introjs.css';
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import { useHistory, useLocation } from 'react-router-dom';

import { AxiosRequestConfig } from 'axios';
import { useMediaQuery } from 'react-responsive';
import GenericNavBar from 'newComponents/GenericNavBar';
import Loading from 'components/layout/loading';
import { Pagination } from 'design-system';
import ModalContent from 'components/Granel/boletos/Modal';
import ModalFilter from 'components/Granel/boletos/Filter/Modal';

import { insertScrollTop } from 'utils/scroll';
import scrollBlock from 'utils/functions/scrollBlock';
import { verifyUser } from 'utils/functions';

import api from 'services/api';

import { pushGtmEvent } from 'analytics/gtm';
import { useTour } from 'hooks/useTour';
import BannerPromotions from 'BannerPromotions';
import SortModal from './SortModal';
import { steps, stepsMobile } from './providers';

import {
  HeaderPage,
  ButtonsContainer,
  SortButton,
  SortIcon,
  ActionsButton,
  DropdownSeparator,
  FilterButton,
  FilterIcon,
  FilterText,
  ClearButton,
  Hr,
  StyledModal,
} from './styles';
import bannerFraude from 'design-system/assets/banner-fraude.png';
import bannerFraudeMobile from 'design-system/assets/banner-fraude-mobile.png';

import { FraudBanner, FiltersBar, PageHeader, BankSlipTable, SelectionBar, EmailModal } from './components';
import { isValidEmail } from './components/EmailModal';
import type { BankSlipSortKey } from './components';
import { BannerWrap, Intro, TopSection } from './components/TopSection/styles';
import {
  ContentCard,
  FiltersSection,
  LegacyToolbar,
  PageContent,
  PaginationWrap,
  SelectionBarWrap,
  TableArea,
} from './pageStyles';
import {
  getBoletoNumber,
  formatInstallmentAmount,
} from './utils/bankSlipDisplay';
import {
  BankSlipFilterValues,
  buildSearchFromFilters,
  formatDueDateInput,
  getCompetenceOptions,
  getCompetenceDateRange,
  hasActiveFilters,
  isSearchPending,
  isSearchReadyToApply,
  matchesCompetence,
  matchesDueDate,
  matchesInstallmentAmount,
  matchesTypeableLine,
  parseDueDateToIso,
  parseSearchTerm,
  readApiFiltersFromSearch,
  readFiltersFromSearch,
  getInstallmentCompetence,
  SEARCH_MIN_LENGTH,
} from './utils/filterParams';
import { emailBankSlipsBulk, runBankSlipAction } from './utils/bankSlipActions';
import {
  showBankSlipDownloadSuccessToast,
  showBankSlipEmailSuccessToast,
} from './utils/bankSlipToast';

const FRAUD_BANNER_HREF =
  'https://www.ultragaz.com.br/golpe-do-boleto-falso-como-se-proteger';

const BankSlip: React.FC = (props) => {
  const history = useHistory();
  const location = useLocation();
  const [closeModal, setCloseModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [stepsEnabled, setStepsEnabled] = useState<boolean>(false);
  const [stepResponsive, setStepResponsive] = useState<boolean>(false);
  const [bankslipForDownload, setBankslipForDownload] = useState<any[]>([]);
  const [bankSlips, setBankSlips] = useState<any[]>([]);
  const [hasFilter, setHasFilter] = useState<boolean>(false);
  const [modalOrganization, setModalOrganization] = useState<boolean>(false);
  const [selectAllInvoices, setSelectAllInvoices] = useState<boolean>(false);
  const [modalFilter, setModalFilter] = useState<boolean>(false);
  const [orderBy, setOrderBy] = useState<string>('');
  const [modalPayment, setModalPayment] = useState<any>();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalInstallments, setModalInstallments] = useState<any>();
  const [pageTotal, setPageTotal] = useState<number>(0);
  const [activePage, setActivePage] = useState<number>(1);
  const [emailModalOpen, setEmailModalOpen] = useState<boolean>(false);
  const [emailModalEmail, setEmailModalEmail] = useState<string>('');
  const [emailModalLoading, setEmailModalLoading] = useState<boolean>(false);
  const [emailModalRow, setEmailModalRow] = useState<any>(null);
  const [emailModalBulkItems, setEmailModalBulkItems] = useState<any[]>([]);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const { showTour, tourType, tourStep, setTourType, setSteps } = useTour();
  const showMobileMode = useMediaQuery({ maxWidth: 768 });
  const showDesktopLayout = useMediaQuery({ minWidth: 993 });
  const [tableSort, setTableSort] = useState<{
    key: BankSlipSortKey;
    direction: 'asc' | 'desc';
  } | null>(null);

  const filterValues = useMemo(
    () => readFiltersFromSearch(location.search),
    [location.search]
  );
  const competenceOptions = useMemo(
    () => getCompetenceOptions(filterValues.competence),
    [filterValues.competence]
  );
  const [searchInput, setSearchInput] = useState(filterValues.search);
  const [dueDateInput, setDueDateInput] = useState(filterValues.dueDate);
  const searchPending = isSearchPending(searchInput, filterValues.search);
  const searchHint = searchPending
    ? `Digite pelo menos ${SEARCH_MIN_LENGTH} caracteres para buscar`
    : undefined;
  const expandCardForEmptyFilter =
    hasFilter && !loading && bankSlips.length === 0 && !searchPending;

  const activeModeDownload = true;

  useEffect(() => {
    setSearchInput(filterValues.search);
  }, [filterValues.search]);

  useEffect(() => {
    setDueDateInput(filterValues.dueDate);
  }, [filterValues.dueDate]);

  const applyFilters = useCallback(
    (next: Partial<BankSlipFilterValues>) => {
      const merged = { ...filterValues, ...next };
      const query = buildSearchFromFilters(merged);

      history.push(query ? `/boletos?${query}` : '/boletos');
      setActivePage(1);
    },
    [filterValues, history]
  );

  useEffect(() => {
    const timer = window.setTimeout(() => {
      if (searchInput === filterValues.search) return;

      if (!isSearchReadyToApply(searchInput)) {
        if (filterValues.search) {
          applyFilters({ search: '' });
        }
        return;
      }

      applyFilters({ search: searchInput });
    }, 500);

    return () => window.clearTimeout(timer);
  }, [searchInput, filterValues.search, applyFilters]);

  const handleDueDateChange = useCallback(
    (value: string) => {
      const formatted = formatDueDateInput(value);
      setDueDateInput(formatted);

      if (!formatted) {
        applyFilters({ dueDate: '' });
        return;
      }

      if (formatted.length === 10) {
        const isoDate = parseDueDateToIso(formatted);

        if (isoDate) {
          applyFilters({ dueDate: formatted });
        } else {
          toast.error('Informe uma data de vencimento válida');
        }
      }
    },
    [applyFilters]
  );

  const handleCompetenceChange = useCallback(
    (value: string) => {
      applyFilters({ competence: value });
    },
    [applyFilters]
  );

  const handleStatusChange = useCallback(
    (value: string) => {
      applyFilters({ status: value });
    },
    [applyFilters]
  );

  useEffect(() => {
    setTourType('bankslip');
    setSteps(1);
  }, [showTour, setTourType, setSteps]);

  // @ts-ignore
  const organizeBankSlips = useCallback(async (response) => {
    const { search } = window.location;
    const params = new URLSearchParams(search);
    const filterStatus = params.get('status');
    const competence = params.get('competence');
    const searchQuery = params.get('busca');
    const { typeableLineSearch, totalAmount } = parseSearchTerm(searchQuery || '');
    const beginDateParam = params.get('begin-date');
    const endDateParam = params.get('end-date');
    const filterBeginDate = beginDateParam
      ? moment(beginDateParam, 'YYYY-MM-DD').startOf('day')
      : null;
    const filterEndDate = endDateParam
      ? moment(endDateParam, 'YYYY-MM-DD').startOf('day')
      : null;
    let bankSlipsForEdited: any[] = [];

    const isDueDateInRange = (installmentDueDate: string) => {
      if (!filterBeginDate || !filterEndDate) return true;

      const dueDate = moment(installmentDueDate).startOf('day');

      return (
        dueDate.isSameOrAfter(filterBeginDate, 'day') &&
        dueDate.isSameOrBefore(filterEndDate, 'day')
      );
    };

    // @ts-ignore
    response.forEach((invoice) => {
      // @ts-ignore
      invoice.installments.forEach((installment) => {
        // Filtros por Status
        if (!installment.typeableLine) return;

        if (filterStatus && !beginDateParam) {
          if (filterStatus === 'Pagos' && installment.paymentStatus === 'CL') {
            bankSlipsForEdited = [
              ...bankSlipsForEdited,
              { installment, invoice },
            ];
          } else if (
            filterStatus === 'Vencido' &&
            installment.paymentStatus === 'OP'
          ) {
            const dueDate = new Date(installment.dueDate);
            dueDate.setDate(dueDate.getDate() + 1);
            const currentDate = new Date();
            if (currentDate > dueDate)
              bankSlipsForEdited = [
                ...bankSlipsForEdited,
                { installment, invoice },
              ];
          } else if (
            filterStatus === 'A vencer' &&
            installment.paymentStatus === 'OP'
          ) {
            const dueDate = new Date(installment.dueDate);
            const currentDate = new Date();
            if (currentDate <= dueDate)
              bankSlipsForEdited = [
                ...bankSlipsForEdited,
                { installment, invoice },
              ];
          } else if (filterStatus === 'Todos') {
            bankSlipsForEdited = [
              ...bankSlipsForEdited,
              { installment, invoice },
            ];
          }
        }

        // Filtros por data
        else if (beginDateParam && endDateParam) {
          const dueDate = moment(installment.dueDate);

          if (
            (!filterStatus || filterStatus === 'Todos') &&
            isDueDateInRange(installment.dueDate)
          ) {
            bankSlipsForEdited = [
              ...bankSlipsForEdited,
              { installment, invoice },
            ];
          } else if (filterStatus === 'Pagos' && installment.paymentStatus === 'CL') {
            if (isDueDateInRange(installment.dueDate)) {
              bankSlipsForEdited = [
                ...bankSlipsForEdited,
                { installment, invoice },
              ];
            }
          } else if (
            filterStatus === 'Vencido' &&
            installment.paymentStatus === 'OP'
          ) {
            const currentDate = new Date();
            if (currentDate > dueDate.toDate()) {
              if (isDueDateInRange(installment.dueDate)) {
                bankSlipsForEdited = [
                  ...bankSlipsForEdited,
                  { installment, invoice },
                ];
              }
            }
          } else if (
            filterStatus === 'A vencer' &&
            installment.paymentStatus === 'OP'
          ) {
            const currentDate = new Date();
            if (currentDate <= dueDate.toDate()) {
              if (isDueDateInRange(installment.dueDate)) {
                bankSlipsForEdited = [
                  ...bankSlipsForEdited,
                  { installment, invoice },
                ];
              }
            }
          }
        } else {
          bankSlipsForEdited = [
            ...bankSlipsForEdited,
            { installment, invoice },
          ];
        }
      });
    });

    if (competence) {
      bankSlipsForEdited = bankSlipsForEdited.filter(({ installment, invoice }) =>
        matchesCompetence(installment, invoice, competence)
      );
    }

    if (typeableLineSearch) {
      bankSlipsForEdited = bankSlipsForEdited.filter(({ installment }) =>
        matchesTypeableLine(installment.typeableLine, typeableLineSearch)
      );
    }

    if (totalAmount) {
      bankSlipsForEdited = bankSlipsForEdited.filter(({ installment, invoice }) =>
        matchesInstallmentAmount(installment, invoice, totalAmount)
      );
    }

    if (beginDateParam && endDateParam) {
      bankSlipsForEdited = bankSlipsForEdited.filter(({ installment }) =>
        matchesDueDate(installment.dueDate, beginDateParam, endDateParam)
      );
    }

    setBankSlips(bankSlipsForEdited);
  }, []);

  const requestInvoices = useCallback(
    // @ts-ignore
    (token, beginDate, endDate, status, competence) => {
      const customerCode = localStorage.getItem(
        '@UltragazEmpresarial:customerCode'
      );
      const customerSiteCode = localStorage.getItem(
        '@UltragazEmpresarial:customerSiteCode'
      );
      const header = {
        'Content-Type': 'application/json',
        access_token: token,
      };
      const parameters = {
        method: 'POST',
        headers: header,
        params: {
          'customer-site-code': customerSiteCode,
          'customer-code': customerCode,
          'typeable-line': 'NOT_NULL',
          _expand: 'installments',
          _limit: 5,
          _offset: activePage - 1,
          _order_by: orderBy,
        },
      } as any;

      let apiBeginDate = beginDate;
      let apiEndDate = endDate;

      if (competence) {
        const competenceRange = getCompetenceDateRange(competence);

        if (
          competenceRange &&
          (!beginDate || !endDate || beginDate === endDate)
        ) {
          apiBeginDate = competenceRange.beginDate;
          apiEndDate = competenceRange.endDate;
        }
      }

      if (apiBeginDate && apiEndDate && apiBeginDate !== apiEndDate) {
        parameters.params['begin-date'] = apiBeginDate;
        parameters.params['end-date'] = apiEndDate;
      }

      if (status && status !== 'Todos') {
        let statusFilter;
        switch (status) {
          case 'A vencer':
            statusFilter = 'A_VENCER';
            break;
          case 'Pagos':
            statusFilter = 'PAGO';
            break;
          case 'Vencido':
            statusFilter = 'VENCIDO';
            break;

          default:
            break;
        }
        parameters.params.status = statusFilter;
      }

      api
        .get(`industrial/invoice/v1/invoices`, parameters as AxiosRequestConfig)
        .then((res) => {
          if (!isMountedRef.current) return;

          setLoading(false);
          const pageTotalResponse = res.headers['total-pages'];
          setPageTotal(pageTotalResponse);

          if (res.status === 200) {
            const response = res.data;

            organizeBankSlips(response);
          }
        })
        .catch((err) => {
          if (!isMountedRef.current) return;

          setLoading(false);
          const erro = err.response;
          if (erro) {
            const { message } = err.response.data;
            if (err.response.status !== 401) {
              toast.error(message);
            }
          } else if (err.response.status !== 401) {
            toast.error('Ocorreu um erro interno na aplicação');
          }
        });
    },
    [activePage, orderBy, organizeBankSlips]
  );

  const applyFilterAndRequestInvoices = useCallback(async () => {
    if (!closeModal && !showModal) {
      setLoading(true);
    }
    const token = localStorage.getItem('@UltragazEmpresarial:accessToken');
    const apiFilters = readApiFiltersFromSearch(location.search);

    setHasFilter(hasActiveFilters(location.search));

    if (token) {
      requestInvoices(
        token,
        apiFilters.beginDate,
        apiFilters.endDate,
        apiFilters.status,
        apiFilters.competence
      );
    } else {
      verifyUser(props);
    }
    setCloseModal(false);
  }, [props, requestInvoices, closeModal, showModal, location.search]);

  const onExit = useCallback(() => {
    setStepsEnabled(false);
    scrollBlock('#outer-container', 'body', false);
  }, [setStepsEnabled]);

  const handleSetStepResponsive = useCallback(() => {
    setStepResponsive(window.matchMedia('(max-width: 1100px)').matches);
  }, [setStepResponsive]);

  const toggleSteps = useCallback(() => {
    handleSetStepResponsive();
    setStepsEnabled((oldState) => !oldState);
    scrollBlock('#outer-container', 'body', true);
  }, [handleSetStepResponsive]);

  const clearSelectAllInvoices = useCallback(() => {
    setSelectAllInvoices(false);
    setBankslipForDownload([]);
  }, []);

  const requestDownload = useCallback(
    (method: string, items = bankslipForDownload) => {
      if (!items.length) return;

      setLoading(true);
      const token = localStorage.getItem('@UltragazEmpresarial:accessToken');
      const customerCode = localStorage.getItem(
        '@UltragazEmpresarial:customerCode'
      );
      const customerSiteCode = localStorage.getItem(
        '@UltragazEmpresarial:customerSiteCode'
      );
      const header = {
        'Content-Type': 'application/json',
        access_token: token,
      };
      const parameters = {
        method: 'POST',
        responseType: 'blob',
        headers: header,
      };
      const body = {
        customerCode,
        customerSiteCode,
        deliveryMethod: method,
        bankslips: [...items],
      };

      api
        .post(
          '/industrial/invoice/v1/duplicates',
          body,
          parameters as AxiosRequestConfig
        )
        .then((response) => {
          if (!isMountedRef.current) return;

          if (method === 'DOWNLOAD') {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
              'download',
              `ultra_${body.bankslips.length}_boletos.zip`
            );
            document.body.appendChild(link);
            link.click();
            if (link.parentNode) {
              link.parentNode.removeChild(link);
            }
            showBankSlipDownloadSuccessToast(body.bankslips.length > 1);
          }
          if (method === 'EMAIL') {
            showBankSlipEmailSuccessToast();
          }
          clearSelectAllInvoices();
          setLoading(false);
        })
        .catch((err) => {
          if (!isMountedRef.current) return;

          setLoading(false);
          clearSelectAllInvoices();
          toast.error(err.message);
        });
    },
    [bankslipForDownload, clearSelectAllInvoices]
  );

  const clearFilter = useCallback(() => {
    history.push('/boletos');
  }, [history]);

  const handleSetSelectAllInvoices = useCallback(() => {
    setSelectAllInvoices(!selectAllInvoices);
    setBankslipForDownload([]);

    if (selectAllInvoices === false) {
      const newBankSlips = bankSlips
        // @ts-ignore
        .filter((item) => {
          if (
            item.installment.status !== 'PAGO' &&
            item.invoice.accessKey !== undefined
          ) {
            return item.invoice.invoiceId !== undefined;
          }
          return null;
        })
        .map((item) => {
          return {
            invoiceId: item.invoice.invoiceId,
            installmentId: item.installment.installmentId,
          };
        });
      setBankslipForDownload(newBankSlips);
    }

    if (selectAllInvoices === true) {
      setBankslipForDownload([]);
    }
  }, [bankSlips, selectAllInvoices]);

  const handleOrganization = useCallback(
    // @ts-ignore
    (bankSlipsOrder: any[], organizationType: string) => {
      if (organizationType === 'maiorValor') {
        setOrderBy('amountOriginal DESC');
      } else if (organizationType === 'menorValor') {
        setOrderBy('amountOriginal ASC');
      } else if (organizationType === 'notaMaior') {
        setOrderBy('invoiceNumber DESC');
      } else if (organizationType === 'notaMenor') {
        setOrderBy('invoiceNumber ASC');
      } else if (organizationType === 'maiorData') {
        setOrderBy('dueDate DESC');
      } else if (organizationType === 'menorData') {
        setOrderBy('dueDate ASC');
      }

      setBankSlips(bankSlipsOrder);
      setModalOrganization(false);
    },
    []
  );

  // @ts-ignore
  const getStatus = useCallback((installment: any) => {
    const currentDate = new Date();
    const dueDate = new Date(installment.dueDate);
    let status;
    dueDate.setDate(dueDate.getDate() + 1);
    if (installment.paymentStatus === 'OP') {
      if (currentDate > dueDate) status = 'Vencido';
      if (currentDate <= dueDate) status = 'A vencer';
    } else {
      status = 'Pago';
    }
    return status;
  }, []);

  // @ts-ignore
  const handleShow = useCallback((payment, installmentsChange) => {
    if (payment && installmentsChange) {
      setModalPayment(payment);
      setShowModal(true);
      setModalInstallments(installmentsChange);
    }
  }, []);

  const tableSortKey = useMemo((): BankSlipSortKey | null => {
    if (tableSort?.key === 'boleto' || tableSort?.key === 'competencia') {
      return tableSort.key;
    }

    if (orderBy.startsWith('amountOriginal')) return 'valor';
    if (orderBy.startsWith('dueDate')) return 'vencimento';
    if (orderBy.startsWith('invoiceNumber')) return 'nota';

    return null;
  }, [orderBy, tableSort]);

  const tableSortDirection = useMemo((): 'asc' | 'desc' | null => {
    if (
      tableSort &&
      (tableSort.key === 'boleto' || tableSort.key === 'competencia')
    ) {
      return tableSort.direction;
    }

    if (orderBy.endsWith('ASC')) return 'asc';
    if (orderBy.endsWith('DESC')) return 'desc';

    return null;
  }, [orderBy, tableSort]);

  const desktopEmptyMessage = useMemo(() => {
    if (loading && !searchPending) return 'Carregando...';

    if (!loading && hasFilter && !searchPending) {
      return 'Você não possui boletos para esse filtro!';
    }

    if (!loading && !hasFilter) {
      return 'Você não possui boletos!';
    }

    if (String(pageTotal) === String(activePage)) {
      return 'Nenhum registro disponível!';
    }

    return 'Nenhum registro disponível!';
  }, [loading, searchPending, hasFilter, pageTotal, activePage]);

  const selectedTotalLabel = useMemo(() => {
    const total = bankslipForDownload.reduce((sum, item) => {
      const slip = bankSlips.find(
        (bankSlip) => bankSlip.invoice.invoiceId === item.invoiceId
      );

      if (!slip) return sum;

      const amount =
        slip.installment.amountOriginal ?? slip.invoice.totalAmount ?? 0;

      return sum + Number(amount);
    }, 0);

    return total.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  }, [bankslipForDownload, bankSlips]);

  const emailModalBoletoCount = emailModalRow ? 1 : emailModalBulkItems.length;

  const emailModalTotalAmount = useMemo(() => {
    if (emailModalRow) {
      return formatInstallmentAmount(
        emailModalRow.installment,
        emailModalRow.invoice
      );
    }

    const total = emailModalBulkItems.reduce((sum, item) => {
      const slip = bankSlips.find(
        (bankSlip) => bankSlip.invoice.invoiceId === item.invoiceId
      );

      if (!slip) return sum;

      const amount =
        slip.installment.amountOriginal ?? slip.invoice.totalAmount ?? 0;

      return sum + Number(amount);
    }, 0);

    return total.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  }, [emailModalBulkItems, emailModalRow, bankSlips]);

  const handleTableSort = useCallback(
    (key: BankSlipSortKey) => {
      if (key === 'boleto' || key === 'competencia') {
        setTableSort((previous) => {
          const direction =
            previous?.key === key && previous.direction === 'asc'
              ? 'desc'
              : 'asc';

          const sorted = [...bankSlips].sort((first, second) => {
            if (key === 'boleto') {
              const comparison = getBoletoNumber(
                first.installment.typeableLine
              ).localeCompare(
                getBoletoNumber(second.installment.typeableLine),
                undefined,
                { numeric: true }
              );

              return direction === 'asc' ? comparison : -comparison;
            }

            const firstCompetence =
              getInstallmentCompetence(first.installment, first.invoice) || '';
            const secondCompetence =
              getInstallmentCompetence(second.installment, second.invoice) || '';
            const comparison = firstCompetence.localeCompare(secondCompetence);

            return direction === 'asc' ? comparison : -comparison;
          });

          setBankSlips(sorted);

          return { key, direction };
        });

        return;
      }

      if (key === 'valor') {
        const organizationType =
          orderBy === 'amountOriginal ASC' ? 'maiorValor' : 'menorValor';

        handleOrganization(bankSlips, organizationType);
        setTableSort(null);
        return;
      }

      if (key === 'nota') {
        const organizationType =
          orderBy === 'invoiceNumber ASC' ? 'notaMenor' : 'notaMaior';

        handleOrganization(bankSlips, organizationType);
        setTableSort(null);
        return;
      }

      const organizationType =
        orderBy === 'dueDate ASC' ? 'maiorData' : 'menorData';

      handleOrganization(bankSlips, organizationType);
      setTableSort(null);
    },
    [bankSlips, handleOrganization, orderBy]
  );

  const handleRowDownload = useCallback(async (row) => {
    setLoading(true);

    try {
      await runBankSlipAction(row, 'DOWNLOAD');

      if (!isMountedRef.current) return;

      showBankSlipDownloadSuccessToast();
    } catch (error) {
      if (!isMountedRef.current) return;

      toast.error(error?.message || 'Ocorreu um erro ao baixar o boleto');
    } finally {
      if (isMountedRef.current) {
        setLoading(false);
      }
    }
  }, []);

  const handleRowSendEmail = useCallback((row) => {
    setEmailModalRow(row);
    setEmailModalBulkItems([]);
    setEmailModalEmail(
      localStorage.getItem('@UltragazEmpresarial:loginEmail') ?? ''
    );
    setEmailModalOpen(true);
  }, []);

  const handleOpenBulkEmailModal = useCallback(() => {
    if (!bankslipForDownload.length) return;

    setEmailModalRow(null);
    setEmailModalBulkItems([...bankslipForDownload]);
    setEmailModalEmail(
      localStorage.getItem('@UltragazEmpresarial:loginEmail') ?? ''
    );
    setEmailModalOpen(true);
  }, [bankslipForDownload]);

  const handleEmailModalClose = useCallback(() => {
    if (emailModalLoading) return;

    setEmailModalOpen(false);
    setEmailModalRow(null);
    setEmailModalBulkItems([]);
  }, [emailModalLoading]);

  const handleEmailModalSubmit = useCallback(async () => {
    if (!isValidEmail(emailModalEmail)) return;

    const email = emailModalEmail.trim();
    setEmailModalLoading(true);

    try {
      if (emailModalRow) {
        await runBankSlipAction(emailModalRow, 'EMAIL', { email });
      } else if (emailModalBulkItems.length) {
        await emailBankSlipsBulk(emailModalBulkItems, email);
        clearSelectAllInvoices();
      } else {
        return;
      }

      if (!isMountedRef.current) return;

      showBankSlipEmailSuccessToast();
      setEmailModalOpen(false);
      setEmailModalRow(null);
      setEmailModalBulkItems([]);
    } catch (error) {
      if (!isMountedRef.current) return;

      toast.error(error?.message || 'Ocorreu um erro ao enviar o boleto');
    } finally {
      if (isMountedRef.current) {
        setEmailModalLoading(false);
      }
    }
  }, [
    clearSelectAllInvoices,
    emailModalBulkItems,
    emailModalEmail,
    emailModalRow,
  ]);

  const handleRowView = useCallback(
    (row) => {
      handleShow(row.invoice, row.installment);
    },
    [handleShow]
  );

  const selectInvoicesForDownload = useCallback(
    // @ts-ignore
    (invoiceId, source, accessKey, status, installmentId) => {
      if (status !== 'PAGO' && accessKey !== undefined) {
        if (selectAllInvoices === true) {
          setSelectAllInvoices(false);
        }
        if (bankslipForDownload.find((item) => invoiceId === item.invoiceId)) {
          setBankslipForDownload(
            bankslipForDownload.filter((item) => item.invoiceId !== invoiceId)
          );
        } else {
          setBankslipForDownload([
            ...bankslipForDownload,
            {
              invoiceId,
              installmentId,
            },
          ]);
        }
      }
    },
    [bankslipForDownload, selectAllInvoices]
  );

  const goTop = useCallback(() => {
    const width = window.innerWidth;
    if (width <= 455) {
      insertScrollTop(220);
    } else {
      insertScrollTop(200);
    }
  }, []);

  const handleChangePage = useCallback(
    (pageNumber: number) => {
      setActivePage(pageNumber);
      goTop();
    },
    [goTop]
  );

  useEffect(() => {
    applyFilterAndRequestInvoices();
  }, [applyFilterAndRequestInvoices, activePage, orderBy, location.search]);

  useEffect(() => {
    if (closeModal) {
      applyFilterAndRequestInvoices();
    }
  }, [applyFilterAndRequestInvoices, closeModal]);

  const modalInstallmentId = modalInstallments?.installmentId;

  useEffect(() => {
    if (!showModal || !modalInstallmentId) return;

    const matchingSlip = bankSlips.find(
      (bankSlip) => bankSlip?.installment?.installmentId === modalInstallmentId
    );

    if (!matchingSlip?.installment) return;

    setModalInstallments(matchingSlip.installment);
  }, [bankSlips, modalInstallmentId, showModal]);

  return (
    <GenericNavBar
      selected="boletos"
      withTable
      breadcrump="› Boletos"
      intro={toggleSteps}
    >
      {!loading && (
        <Steps
          enabled={stepsEnabled}
          steps={stepResponsive ? stepsMobile : steps}
          initialStep={0}
          onExit={onExit}
          options={{
            skipLabel: "<span class='mdi mdi-close'></span>",
            doneLabel: "<span class='mdi mdi-close'></span>",
            showStepNumbers: false,
            scrollToElement: false,
          }}
        />
      )}
      <PageContent>
        <TopSection>
          <Intro>
            <PageHeader
              title="Boletos"
              description="Acompanhe suas faturas e baixe a 2ª via com facilidade."
            />
          </Intro>

          <BannerWrap>
            <FraudBanner
              href={FRAUD_BANNER_HREF}
              imageSrc={showMobileMode ? bannerFraudeMobile : bannerFraude}
              isMobile={showMobileMode}
            />
          </BannerWrap>
        </TopSection>

        <ContentCard $expandWhenEmpty={expandCardForEmptyFilter}>
          <FiltersSection>
            <FiltersBar
              searchValue={searchInput}
              dueDateValue={dueDateInput}
              competenceValue={filterValues.competence}
              statusValue={filterValues.status}
              competenceOptions={competenceOptions}
              searchHint={searchHint}
              onSearchChange={setSearchInput}
              onDueDateChange={handleDueDateChange}
              onCompetenceChange={handleCompetenceChange}
              onStatusChange={handleStatusChange}
            />
          </FiltersSection>

          <TableArea $expandWhenEmpty={expandCardForEmptyFilter}>
            <LegacyToolbar>
              <HeaderPage>
        {activeModeDownload && (
          <>
            {bankslipForDownload.length >= 1 && (
              <span className="selected-download-message">
                <b>
                  {`Você selecionou ${bankslipForDownload.length} ${
                    bankslipForDownload.length > 1 ? 'boletos.' : 'boleto.'
                  }`}
                </b>
              </span>
            )}
          </>
        )}
        <ButtonsContainer hasFilter={hasFilter}>
          <SortButton onClick={() => setModalOrganization(true)}>
            <SortIcon className="mdi mdi-swap-vertical" />
            Ordenar
          </SortButton>
          {bankslipForDownload.length >= 1 && (
            <ActionsButton id="dropdown-mobile-order">
              <ActionsButton.Toggle id="ActionsButton">
                {activeModeDownload && bankslipForDownload.length >= 1 && (
                  <>
                    Baixar/enviar boletos
                    <span id="for-mail"> por e-mail</span>
                  </>
                )}
              </ActionsButton.Toggle>
              <ActionsButton.Menu>
                <ActionsButton.Item onClick={() => clearSelectAllInvoices()}>
                  <>
                    <span className="mdi mdi-close" />
                    Cancelar Seleção
                  </>
                </ActionsButton.Item>
                {activeModeDownload && bankslipForDownload.length >= 1 && (
                  <>
                    <DropdownSeparator />
                    <ActionsButton.Item
                      onClick={() => requestDownload('DOWNLOAD')}
                    >
                      <span className="mdi mdi-download" />
                      {`Baixar ${bankslipForDownload.length} ${
                        bankslipForDownload.length > 1 ? 'boletos' : 'boleto'
                      }`}
                    </ActionsButton.Item>
                    <DropdownSeparator />
                    <ActionsButton.Item
                      onClick={handleOpenBulkEmailModal}
                    >
                      <span className="mdi mdi-email" />
                      {`Enviar ${bankslipForDownload.length} ${
                        bankslipForDownload.length > 1 ? 'boletos' : 'boleto'
                      } por e-mail`}
                    </ActionsButton.Item>
                  </>
                )}
              </ActionsButton.Menu>
            </ActionsButton>
          )}
          <FilterButton
            hasFilter={hasFilter}
            onClick={() => {
              pushGtmEvent({
                event: 'click_cta',
                eventCategory: 'funcao',
                eventAction: 'click',
                eventLabel: 'filtrar',
                pageSection: 'boletos',
                elementType: 'button',
                elementTitle: 'Boletos',
              });
              setModalFilter(true);
            }}
          >
            <FilterIcon />
            <FilterText>Filtrar</FilterText>
          </FilterButton>
          {hasFilter ? (
            <ClearButton onClick={() => clearFilter()}>
              <SortIcon className="mdi mdi-close" />
              Limpar Filtros
            </ClearButton>
          ) : null}
        </ButtonsContainer>
              </HeaderPage>
              <Hr />
            </LegacyToolbar>

            {bankslipForDownload.length >= 1 && (
              <SelectionBarWrap>
                <SelectionBar
                  selectedCount={bankslipForDownload.length}
                  totalLabel={selectedTotalLabel}
                  onDownload={() => requestDownload('DOWNLOAD')}
                  onSendEmail={handleOpenBulkEmailModal}
                  disabled={loading}
                />
              </SelectionBarWrap>
            )}

            <BankSlipTable
              compact={!showDesktopLayout}
              rows={bankSlips.filter(({ installment }) => installment.typeableLine)}
              selectedIds={bankslipForDownload.map((item) => item.invoiceId)}
              selectAllChecked={selectAllInvoices}
              sortKey={tableSortKey}
              sortDirection={tableSortDirection}
              emptyMessage={desktopEmptyMessage}
              onToggleSelectAll={handleSetSelectAllInvoices}
              onToggleRow={(invoiceId, installmentId) => {
                const row = bankSlips.find(
                  (bankSlip) => bankSlip.invoice.invoiceId === invoiceId
                );

                if (!row) return;

                selectInvoicesForDownload(
                  invoiceId,
                  row.invoice.source,
                  row.invoice.accessKey,
                  row.installment.status,
                  installmentId
                );
              }}
              onSort={handleTableSort}
              onView={handleRowView}
              onDownload={handleRowDownload}
              onSendEmail={handleRowSendEmail}
            />
          </TableArea>
          {pageTotal > 0 && (
            <PaginationWrap>
              <Pagination
                page={activePage}
                totalPages={pageTotal}
                onPageChange={handleChangePage}
                disabled={loading}
                size="sm"
                color="#575757"
                activeBackgroundColor="#000FFF"
                activeColor="#fff"
                showFirstLast
              />
            </PaginationWrap>
          )}
        </ContentCard>
      </PageContent>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        animation={false}
        centered
      >
        <ModalContent
          // @ts-ignore
          close={() => {
            setShowModal(false);
            setCloseModal(true);
          }}
          payment={modalPayment}
          installment={modalInstallments}
          setCloseModal={setCloseModal}
          showMobileMode={showMobileMode}
        />
      </Modal>
      <StyledModal
        show={modalFilter}
        onHide={() => setModalFilter(false)}
        aria-labelledby="example-custom-modal-styling-title"
        animation={false}
        centered
      >
        <ModalFilter close={() => setModalFilter(false)} />
      </StyledModal>
      <Modal
        show={modalOrganization}
        onHide={() => setModalOrganization(false)}
        size="lg"
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        animation={false}
        centered
      >
        <SortModal
          // @ts-ignore
          close={() => setModalOrganization(false)}
          bankslips={bankSlips}
          sort={handleOrganization}
        />
      </Modal>
      <EmailModal
        open={emailModalOpen}
        email={emailModalEmail}
        boletoCount={emailModalBoletoCount}
        totalAmount={emailModalTotalAmount}
        loading={emailModalLoading}
        onEmailChange={setEmailModalEmail}
        onClose={handleEmailModalClose}
        onSubmit={handleEmailModalSubmit}
      />
      {loading ? <Loading /> : null}
      <BannerPromotions />
    </GenericNavBar>
  );
};

export default BankSlip;
